module.exports = __webpack_public_path__ + "img/outlet.bbdfd2b0.svg";